import React from "react";
import styled from 'styled-components';
import BodyBlocker from "./BodyBlocker";
import Button from './Button';
import { DialogProps } from "./Dialogs";

const Modal = styled.div`
    background: #FFFFFF;
    color: #000000;
    left: 50%;
    max-width: 500px;
    position: fixed;
    text-align: center;
    top: 50%;
    transform: translate(-50%,-50%);
    width: 90%;
    z-index: ${props => props.theme.zIndexes.dialogs};

    body.theme-platinum & {
        background: var(--text-primary);
    }
`;

interface Props {
    dialog: DialogProps;
    onBgClick?: Function;
}

const Dialog: React.FC<Props> = ({ dialog, onBgClick }) => {
    return (
        <>
            <BodyBlocker modal onClick={onBgClick} />
            <Modal className="p-3 fade-in dyn-modal-dialog">
                {dialog.emoji || dialog.icon && <div className="pt-3" style={{ fontSize: '48px' }}>
                    {dialog.emoji || <i className={`fal fa-${dialog.icon}`} />}
                </div>}

                <div className="p-3" dangerouslySetInnerHTML={{ __html: dialog.message }} />

                {dialog.buttons && <div className="p-3">
                    {dialog.buttons.map((button, index) => (
                        <Button className="m-1" focus key={index} {...button} onClick={() => { button.onClick(dialog) }}>
                            {button.label}
                        </Button>
                    ))}
                </div>}
            </Modal>
        </>
    );
};

export default Dialog;